{
  "instances": {
    "flyway": {
      "label": "Flyway",
      "type": "Type",
      "checksum": "Checksum",
      "version": "Version",
      "description": "Description",
      "script": "Script",
      "state": "État",
      "installed_by": "Installé par",
      "installed_on": "Installé sur",
      "installed_rank": "Ordre d'installation",
      "execution_time": "Temps d'éxecution"
    }
  }
}
